/**
 * API Endpoints
 * Central configuration for all API routes
 */

// Base API URL from environment variable
export const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:8000";
export const API_PREFIX = process.env.REACT_APP_API_BASE || "/api";

// Full API URL
export const API_URL = `${API_BASE_URL}${API_PREFIX}`;

// Storage mode configuration
export const USE_GCS_STORAGE = process.env.REACT_APP_USE_GCS_STORAGE === "true";

// Auth Endpoints
export const AUTH_ENDPOINTS = {
  REGISTER: "/auth/register",
  LOGIN: "/auth/login",
} as const;

// User Endpoints
export const USER_ENDPOINTS = {
  ME: "/users/me",
  BY_ID: (userId: string) => `/users/${userId}`,
} as const;

// Job Endpoints
export const JOB_ENDPOINTS = {
  CREATE: "/jobs/create",
  CREATE_WITH_CONFIG: "/api/jobs/create-with-config",
  LIST: "/jobs/",
  BY_ID: (jobId: string) => `/jobs/${jobId}`,
  BY_NUMBER: (jobNumber: number) => `/jobs/number/${jobNumber}`,
  DELETE: (jobId: string) => `/jobs/${jobId}`,
  STATS: "/jobs/stats",
  ANALYZE_FRAME: "/jobs/analyze-frame",
} as const;

// File Endpoints
export const FILE_ENDPOINTS = {
  RESULTS: (path: string) => `/results/${path}`,
  DOWNLOAD: (path: string) => `/download/${path}`,
} as const;

// Health Check
export const HEALTH_ENDPOINTS = {
  ROOT: "/",
  HEALTH: "/api/health",
} as const;

// Polling Configuration
export const POLLING_CONFIG = {
  INTERVAL: parseInt(process.env.REACT_APP_POLLING_INTERVAL || "3000", 10),
  MAX_RETRIES: 3,
} as const;

// Signed URL expiration buffer (refresh 5 minutes before expiration)
export const SIGNED_URL_REFRESH_BUFFER_MS = 5 * 60 * 1000;

export const ADMIN_ENDPOINTS = {
  STATS: "/api/admin/stats",
  JOBS: "/api/admin/jobs",
  USERS: "/api/admin/users",
  UPDATE_USER_ROLE: (userId: string) => `/api/admin/users/${userId}/role`,
  UPDATE_USER_STATUS: (userId: string) => `/api/admin/users/${userId}/status`,
};
